import { render, staticRenderFns } from "./wuliudianzi.vue?vue&type=template&id=54e46c9d&scoped=true&"
import script from "./wuliudianzi.vue?vue&type=script&lang=js&"
export * from "./wuliudianzi.vue?vue&type=script&lang=js&"
import style0 from "./wuliudianzi.vue?vue&type=style&index=0&id=54e46c9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e46c9d",
  null
  
)

export default component.exports